import { componentProvider } from 'js-component-framework';
import SpokeMenu from './snc-spoke-menu';
import './snc-spoke-menu.scss';

const spokeMenuConfig = {
  name: 'spoke-menu',
  component: SpokeMenu,
  querySelector: {},
  querySelectorAll: {},
};

componentProvider(spokeMenuConfig);
